/* eslint-disable no-unused-vars, no-useless-constructor*/
import React, { Component } from 'react';

import utils from '../../utils/utils';
import logger from '../../core/Logger';
import update from 'react-addons-update';

class BaseComponent extends Component {
	
	constructor(props) {
		super(props);
		this.instanceId = utils.guid();
	}
	
	componentDidMount() {
		logger.trace(`${this.constructor.name}:BaseComponent#componentDidMount => guid:`, this.instanceId);
		this.mounted = true;
	}
	
	componentWillUpdate() {
		this.mounted = true;
	}
	
	componentWillUnmount() {
		logger.trace(`${this.constructor.name}:BaseComponent#componentWillUnmount => guid:`, this.instanceId);
		this.mounted = false;
	}
	
	
	/**
	 * Checks if component mounted and sets state using react-addons-update
	 * @param updatePath
	 * @param callback
	 */
	setStateDeep(updatePath, callback) {
		logger.trace(`${this.constructor.name}:BaseComponent#setStateDeep(), updatePath: `, updatePath, ", guid", this.instanceId);
		if(this.mounted) {
			this.setState(update(this.state, updatePath), callback);
		} else {
			logger.warn(`${this.constructor.name}:BaseComponent#setStateDeep(), Tries to update deep state of unmounted component.`, updatePath);
		}
	}
	
	/**
	 * Helper for setting second level state same way as setState is used.
	 * @param subState - key under which the second level state is stored
	 * @param map - data to save into state
	 * @param callback
	 */
	setSecondLevelState(subState,map,callback) {
		let updatePath = {
			[subState]: {}
		};
		for (let key in map) {
			if (map.hasOwnProperty(key)) {
				updatePath[subState][key] = {$set: map[key]};
			}
		}
		this.setStateDeep(updatePath,callback);
	}
	
}

export default BaseComponent;
